var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import * as React from 'react';
import { IntelligentPhotoCaptureAttachmentIterationStatus, IntelligentPhotoCaptureViewType } from '../../enums';
import { addGpsToImage, attachmentIteration, getEstimatorSummaryHeaderText, getFileDescriptionByAttributeType } from '../../utilities';
import { IntelligentGenericWebcamComponent } from './IntelligentGenericWebcamComponent';
import { IntelligentEstimatorCameraComponent } from './IntelligentEstimatorCameraComponent';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
import { IntelligentPhotoCaptureEstimatorLoaderComponent } from './IntelligentPhotoCaptureEstimatorLoaderComponent';
export const IntelligentPhotoCaptureEstimatorCameraView = ({ appTheme, attachmentIterationInfo, estimatorSelectedTileId, lastRenderedView, questionSubType, sequenceScreenName, userVehicleInfo, vehicle, shouldUseIntegratedCamera, onHandleCameraFile, onDeleteAttachmentIteration: handleDeleteAttachmentIteration, onResetCapturedPhoto, onSaveCapturedPhoto, onUpdateIterationUploadingStatus, onViewChange }) => {
    var _a, _b, _c;
    const assignmentSummaryHeaderText = getEstimatorSummaryHeaderText(userVehicleInfo !== null && userVehicleInfo !== void 0 ? userVehicleInfo : vehicle);
    const fileDescription = getFileDescriptionByAttributeType(questionSubType);
    const isGalleryRetakeFlow = lastRenderedView === IntelligentPhotoCaptureViewType.ESTIMATOR_GALLERY;
    const [isCaptureInProgress, setIsCaptureInProgress] = React.useState(false);
    const latestIteration = attachmentIteration.getLatestIteration(attachmentIterationInfo);
    const latestIterationFileCount = (_b = (_a = latestIteration === null || latestIteration === void 0 ? void 0 : latestIteration.cameraFiles) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    const previousIterationFileCountRef = React.useRef(latestIterationFileCount);
    React.useEffect(() => {
        if (isCaptureInProgress && latestIterationFileCount > previousIterationFileCountRef.current) {
            setIsCaptureInProgress(false);
        }
        previousIterationFileCountRef.current = latestIterationFileCount;
    }, [isCaptureInProgress, latestIterationFileCount]);
    const handleCameraCapture = (image) => __awaiter(void 0, void 0, void 0, function* () {
        setIsCaptureInProgress(true);
        const currentDate = moment(new Date()).format('YYYYMMDDHHmmssSSS');
        const imageName = `${currentDate}.jpeg`;
        const fileWithGPS = yield addGpsToImage(image, imageName);
        if (isGalleryRetakeFlow) {
            const capturedRetakePhoto = {
                file: fileWithGPS,
                isCameraCapturedImage: true,
                isSelected: true
            };
            onSaveCapturedPhoto && onSaveCapturedPhoto(capturedRetakePhoto);
            onViewChange(IntelligentPhotoCaptureViewType.ESTIMATOR_GALLERY, sequenceScreenName, estimatorSelectedTileId);
            return;
        }
        onHandleCameraFile(fileWithGPS);
    });
    const handleDoneButton = () => {
        if (latestIteration && latestIteration.cameraFiles && latestIteration.cameraFiles.length) {
            onUpdateIterationUploadingStatus(latestIteration, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED);
            onViewChange(IntelligentPhotoCaptureViewType.NONE);
        }
    };
    const handleBackButton = () => {
        var _a;
        if (isGalleryRetakeFlow) {
            onResetCapturedPhoto && onResetCapturedPhoto();
            onViewChange(IntelligentPhotoCaptureViewType.ESTIMATOR_GALLERY, sequenceScreenName, estimatorSelectedTileId);
            return;
        }
        if (latestIteration) {
            if ((_a = latestIteration.cameraFiles) === null || _a === void 0 ? void 0 : _a.length) {
                onUpdateIterationUploadingStatus(latestIteration, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED);
            }
            else {
                handleDeleteAttachmentIteration(latestIteration.iterationId);
            }
        }
        onViewChange(IntelligentPhotoCaptureViewType.NONE);
    };
    const WebcamComponent = shouldUseIntegratedCamera
        ? IntelligentGenericWebcamComponent
        : IntelligentEstimatorCameraComponent;
    return (React.createElement(React.Fragment, null,
        React.createElement(IntelligentPhotoCaptureEstimatorLoaderComponent, { shouldShowLoader: isCaptureInProgress }),
        React.createElement(IntelligentPBEContainerComponent, { appTheme: appTheme, estimatorSummaryHeaderText: assignmentSummaryHeaderText, isFooter: false, islanguageHide: true, shouldShowAvatar: false, movePrevious: handleBackButton },
            React.createElement(WebcamComponent, { appTheme: appTheme, fileDescription: fileDescription, handleDoneButton: handleDoneButton, isDoneButtonDisabled: !(latestIteration && ((_c = latestIteration.cameraFiles) === null || _c === void 0 ? void 0 : _c.length)), onCapture: handleCameraCapture, shouldFlipCamera: false, shouldHideDeviceLibrary: true, shouldHideDoneButton: isGalleryRetakeFlow }))));
};
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorCameraView.js.map